import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Button from  'js/components/shared/Button'
import PopUp from '../../../PopupRedesign'
import { toggleLogIn, toggleSignUp } from 'js/helpers/loginActions';
import {
  pushCreateAccountAction,
  pushLoginAction,
  pushCheckoutInteractAction,
} from '../../../../helpers/gtm'
import fbLogo from 'assets/images/fb_logo.png';
import googleLogo from 'assets/images/google_logo.png';

import styles from './LastChancePopup.module.scss'

const cx = classnames.bind(styles)

const LastChancePopup = function ({data, onClose}) {
  const {
    message: {
      description,
      link,
      memberRateText,
      becomeMemberLinkText,
      loginLinkText,
      markedText,
      concatenate,
    },
    onCloseFunc,
  } = data;

  const onClickHandler = (e) => {
    e.preventDefault()
    closePopupHandler()
  }

  const onCreateAccountClick = (e) => {
    e.preventDefault();
    pushCreateAccountAction('last chance - become member');
    toggleSignUp();
  }

  const onLoginClick = (e) => {
    e.preventDefault();
    pushLoginAction('last chance - log in')
    toggleLogIn();
  }

  const closePopupHandler = () => {
    pushCheckoutInteractAction({
      bloc_name: 'modale',
      bloc_interaction: 'continue as guest',
    })
    onCloseFunc ? onCloseFunc(onClose) : onClose();
  }

  return (
    <PopUp theme="mobile-full" onClose={closePopupHandler}>
      <div className={cx('root')}>
        <div className={cx('login-section')}>
          <p className={cx('member-rate-text')}>{memberRateText}</p>
          <p className={cx('member-rate-action')}>
            <Button
              href="#create-account"
              color="white"
              className={cx('register-link')}
              onClick={onCreateAccountClick}
            >
              {becomeMemberLinkText}
            </Button>
            {concatenate}
            <span className={cx('login-group')}>
              <a href="#connection" className={cx('login-link')} onClick={onLoginClick}>{loginLinkText}</a>
              <a className={cx('social-link')} href="#google" onClick={onLoginClick}>
                <img src={googleLogo} alt="google"/>
              </a>
              <a className={cx('social-link')} href="#fb" onClick={onLoginClick}>
                <img src={fbLogo} alt="fb"/>
              </a>
            </span>
          </p>
        </div>
        <p className={cx('description')}>
          <span dangerouslySetInnerHTML={{__html: description}} />
          <a onClick={onClickHandler} href={link.url}>{link.title}</a>
        </p>
        {markedText && (<p className={cx('marked-text')}>{markedText}</p>)}
      </div>
    </PopUp>
  )
}

LastChancePopup.propTypes = {
  data: PropTypes.shape({
    message: PropTypes.objectOf(Object).isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default LastChancePopup
